import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';

import { SPACE } from '@/constants';
import { shouldForwardProp } from '@/utils/should-forward-prop';

const Title = styled.div`
  margin-bottom: ${SPACE.X0};
`;

const TextBlock = styled.div`
  margin-bottom: ${SPACE.X2};
`;

const VehicleCardWrapper = styled.div`
  display: flex;
  margin-bottom: ${SPACE.X2};
  width: 100%;
`;

const StyledGrid = styled(Grid, { shouldForwardProp })`
  &.MuiGrid-root.MuiGrid-item {
    display: flex;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const BrowseButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SPACE.X1};
`;

export { BrowseButtonWrapper, StyledGrid, TextBlock, Title, VehicleCardWrapper };
